import { render } from "./TheLikeButton.vue?vue&type=template&id=09ac6c4f&ts=true"
import script from "./TheLikeButton.vue?vue&type=script&lang=ts"
export * from "./TheLikeButton.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__